import { FormPagePropertyItemText } from 'backend';
import { RE_ENTER_PROPERTY_ID_PREFIX } from 'reEnter';
import { FormPageInputData, TEXT_PROPERTY_INPUT_TYPE } from 'shared';
import { PropertyItemElement } from '../getPropertyItemElements';

export const getTextInputValue = (
  propertyItem: FormPagePropertyItemText,
  propertyItemElement: PropertyItemElement,
): FormPageInputData => {
  switch (propertyItem.inputFormat.inputType) {
    case TEXT_PROPERTY_INPUT_TYPE.singleLine: {
      const textElement = propertyItemElement.text;
      if (!(textElement instanceof HTMLInputElement)) {
        return {};
      }
      const textValue = textElement.value;

      const reEnterElement = propertyItemElement.reEnter;
      if (
        !propertyItem.reEnter ||
        !(reEnterElement instanceof HTMLInputElement)
      ) {
        return {
          [propertyItem.propertyId]: {
            inputItemType: 'textSingleLine',
            text: textValue,
          },
        };
      }
      return {
        [propertyItem.propertyId]: {
          inputItemType: 'textSingleLine',
          text: textValue,
        },
        [`${RE_ENTER_PROPERTY_ID_PREFIX}${propertyItem.propertyId}`]: {
          inputItemType: 'textSingleLine',
          text: reEnterElement.value,
        },
      };
    }
    case TEXT_PROPERTY_INPUT_TYPE.multiLine: {
      const textAreaElement = propertyItemElement.textArea;
      if (!(textAreaElement instanceof HTMLTextAreaElement)) {
        return {};
      }
      return {
        [propertyItem.propertyId]: {
          inputItemType: 'textMultiLine',
          text: textAreaElement.value,
        },
      };
    }
    case TEXT_PROPERTY_INPUT_TYPE.name: {
      const lastNameElement = propertyItemElement.lastName;
      const firstNameElement = propertyItemElement.firstName;
      if (
        !(lastNameElement instanceof HTMLInputElement) ||
        !(firstNameElement instanceof HTMLInputElement)
      ) {
        return {};
      }
      return {
        [propertyItem.propertyId]: {
          inputItemType: 'textName',
          lastName: lastNameElement.value,
          firstName: firstNameElement.value,
        },
      };
    }
    case TEXT_PROPERTY_INPUT_TYPE.tel: {
      const firstElement = propertyItemElement.first;
      const secondElement = propertyItemElement.second;
      const thirdElement = propertyItemElement.third;
      if (
        !(firstElement instanceof HTMLInputElement) ||
        !(secondElement instanceof HTMLInputElement) ||
        !(thirdElement instanceof HTMLInputElement)
      ) {
        return {};
      }
      return {
        [propertyItem.propertyId]: {
          inputItemType: 'textTel',
          first: firstElement.value,
          second: secondElement.value,
          third: thirdElement.value,
        },
      };
    }
    case TEXT_PROPERTY_INPUT_TYPE.zipCode: {
      const firstElement = propertyItemElement.first;
      const secondElement = propertyItemElement.second;
      if (
        !(firstElement instanceof HTMLInputElement) ||
        !(secondElement instanceof HTMLInputElement)
      ) {
        return {};
      }
      return {
        [propertyItem.propertyId]: {
          inputItemType: 'textZipCode',
          first: firstElement.value,
          second: secondElement.value,
        },
      };
    }
    case TEXT_PROPERTY_INPUT_TYPE.zipCodeWithoutHyphen: {
      const zipCodeElement = propertyItemElement.zipCode;
      if (!(zipCodeElement instanceof HTMLInputElement)) {
        return {};
      }
      return {
        [propertyItem.propertyId]: {
          inputItemType: 'textZipCodeWithoutHyphen',
          zipCode: zipCodeElement.value,
        },
      };
    }
    case TEXT_PROPERTY_INPUT_TYPE.additionalText: {
      const textElement = propertyItemElement.text;
      if (!(textElement instanceof HTMLInputElement)) {
        return {};
      }
      return {
        [propertyItem.propertyId]: {
          inputItemType: 'textAdditionalText',
          text: textElement.value,
        },
      };
    }
  }
};
